import React, { useState } from 'react';
import { CompareItem } from '@common-modules/product-catalogue';
import { Button, DropdownInput, Modal, Spacing } from '@dls/web';
import { getCompareItemBrand } from '../../helpers/compare-helpers';
import { trans as t } from '../../helpers/localisation';

type PropTypes = {
  candidates: CompareItem[];
  select: (item: CompareItem) => void;
  close: () => void;
};

export const DevicePicker = (props: PropTypes) => {
  const { candidates, select, close } = props;

  const brands = Array.from(new Set(candidates.map(getCompareItemBrand)));
  const [brand, setBrand] = useState('');
  const [modelId, setModelId] = useState('');
  const [brandError, setBrandError] = useState('');
  const [modelError, setModelError] = useState('');
  const models = candidates.filter(item => getCompareItemBrand(item) === brand);
  const selectedModel = candidates.find(item => item.id === modelId);

  const selectBrand = (value: string) => {
    setBrand(value);
    setModelId('');
    setBrandError('');
  };

  const selectModel = (value: string) => {
    setModelId(value);
    setModelError('');
  };

  const confirm = () => {
    if (!brand) {
      setBrandError(t('COMPARE_PICKER_BRAND_ERROR'));
      return;
    }
    if (!selectedModel) {
      setModelError(t('COMPARE_PICKER_MODEL_ERROR'));
      return;
    }
    select(selectedModel);
    close();
  };

  return (
    <Modal
      visible
      title={t('COMPARE_PICKER_TITLE')}
      onClose={close}
      bgColor="white"
    >
      <Modal.Content>
        <Spacing bottom={2}>
          <DropdownInput
            bgColor="haze"
            label={t('COMPARE_PICKER_BRAND_LABEL')}
            value={brand}
            items={brands.map(value => ({ text: value, value }))}
            onChange={(option: { value: string }) => selectBrand(option.value)}
            error={!!brandError}
            hintMessage={brandError}
          />
        </Spacing>
        {brand && (
          <Spacing bottom={3}>
            <DropdownInput
              bgColor="haze"
              label={t('COMPARE_PICKER_MODEL_LABEL')}
              value={modelId}
              items={models.map(item => ({ text: item.title, value: item.id }))}
              onChange={(option: { value: string }) =>
                selectModel(option.value)
              }
              error={!!modelError}
              hintMessage={modelError}
            />
          </Spacing>
        )}
        <Button
          primary
          fullWidth
          text={t('COMPARE_PICKER_CONFIRM')}
          onClick={confirm}
        />
      </Modal.Content>
    </Modal>
  );
};

export default DevicePicker;
